var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKeyboard } from '@fortawesome/pro-regular-svg-icons/faKeyboard';
import { Float, IconContainer } from './styles';
import { sbColors as colors } from 'components/UI-helpers/colors';
import { changeLBShortcutPopupState, changeShortcutPopupState, } from 'store/structureBuilderUI/reducer';
export var ShortCutButton = function (_a) {
    var isLB = _a.isLB;
    var dispatch = useDispatch();
    var handleShortCutModal = function (e) {
        e.stopPropagation();
        isLB
            ? dispatch(changeLBShortcutPopupState(true))
            : dispatch(changeShortcutPopupState(true));
    };
    return (_jsx(Float, { children: _jsx(IconContainer, __assign({ onClick: handleShortCutModal }, { children: _jsx(FontAwesomeIcon, { color: colors.default, style: { fontSize: 20 }, icon: faKeyboard, className: "cursor-pointer" }) })) }));
};
